var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import cxs from 'cxs';
import { t } from 'helpers/i18n';
import { CheckBox } from 'elements';
var FieldCheckbox = /** @class */ (function (_super) {
    __extends(FieldCheckbox, _super);
    function FieldCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleChange = function (checked) {
            _this.props.onChange(_this.props.name, checked, _this.props.column);
        };
        return _this;
    }
    FieldCheckbox.prototype.render = function () {
        var _a = this.props, name = _a.name, value = _a.value, required = _a.required, id = _a.id, tooltipContent = _a.tooltipContent;
        return (React.createElement(CheckBox, { id: id, tooltipContent: tooltipContent, label: t(name) + (required ? '*' : ''), checked: value, className: className, onChange: this.handleChange }));
    };
    return FieldCheckbox;
}(Component));
export default FieldCheckbox;
var className = cxs({});



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldCheckbox.tsx
// module id = 1023
// module chunks = 0